import { render } from "./Support_services.vue?vue&type=template&id=b9f20176&scoped=true"
import script from "./Support_services.vue?vue&type=script&lang=js"
export * from "./Support_services.vue?vue&type=script&lang=js"

import "./Support_services.vue?vue&type=style&index=0&id=b9f20176&lang=css"
import "./Support_services.vue?vue&type=style&index=1&id=b9f20176&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9f20176"]])

export default __exports__